<app-steps class="d-none d-md-block container-steps-md" [hidden]="showSteps()"></app-steps>

<p class="legal-text-bottom paragraph-w-r-12 mb-0 mx-auto text-center d-none d-md-block">©2024 Corporación Actinver S.A.B. de C.V. <br class="d-block d-lg-none"> Todos los derechos reservados.</p>
